import React, { useEffect, useState } from 'react';
import api from '../api';
import NewsCard from './NewsCard';
import './FeaturedNews.css';

export default function FeaturedNews({ title = '⭐ फीचर्ड न्यूज़', fullWidth = false }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchDb = async () => {
      try {
        setLoading(true);
        const res = await api.get('/api/news/featured-db?limit=6');
        const dbItems = (res.data && res.data.success) ? res.data.data || [] : [];
        // sort by featuredAt (newest first), fallback to createdAt
        const sorted = dbItems.slice().sort((a, b) => new Date(b.featuredAt || b.createdAt) - new Date(a.featuredAt || a.createdAt));
        if (mounted) setItems(sorted);
      } catch (err) {
        console.warn('Failed to load DB featured', err.message || err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchDb();
    return () => { mounted = false; };
  }, []);

  if (loading || items.length === 0) return null;

  return (
    <section className="featured-db-section">
      <div className="container">
        <h2 className="section-title">{title}</h2>
        <div className={`featured-db-grid${fullWidth ? ' fullwidth' : ''}`}>
          {items.map((n) => (
            <NewsCard key={n._id || n.title} news={n} featured />
          ))}
        </div>
      </div>
    </section>
  );
}
